import React, { useEffect, useState } from 'react';
//import Conexion from './../conexion/conexion';
import Header from './../elementos/basicos/Header';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Footer from '../elementos/basicos/Footer';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CursoContacto from '../elementos/basicos/CursoContacto';
import FormCurso from '../elementos/complejos/FormCurso';
import { Navigate } from 'react-router-dom';



//Este objeto es el objeto principal que hará referecia al formulario de curso
const FormularioCurso = () => {
    const { Urlpar_1, Urlpar_2, Urlpar_3 } = useParams();

   
    const urlCurso = Urlpar_3 ? `${Urlpar_1}/${Urlpar_2}/${Urlpar_3}` : `${Urlpar_1}/${Urlpar_2}`;

    // console.log(urlCurso);

    const [cursoData, setOcupadosData] = useState(null);

    const [errorData, setErrorData] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            try {

                const responseCursoSelect = await axios.get(`${process.env.REACT_APP_API_URL}/api/curso/${urlCurso}`);
                // console.log(responseCursoSelect.data);
                setOcupadosData(responseCursoSelect.data[0]);

            } catch (error) {
                console.log("Ha habido un error en el form:", error);
                setErrorData(true)
            }
        };

        fetchData();
    }, [urlCurso]);

    //console.log(cursoData);
    if (errorData) {
        // Si hay un error, redirige al usuario a la página de error
        return <Navigate to="/error2" replace />;
    }


    return (
        <>
            {cursoData && (
                <>
            <Header />
            <Contenedor>

                <FilaCursos>
                
                    <Col lg="7">
                         
                        {
                            //apartado en referencia al curso
                        }
                            <CursoContacto curso={cursoData}  />
                         
                         

                    </Col>


                    <CuerpoCursos lg="5">
                        {
                            //apartado en referencia al formulario
                        }
                         <FormCurso curso={cursoData}  /> 

                    </CuerpoCursos>

                </FilaCursos>
            </Contenedor>

            <Footer />

            </>
            )}   


        </>
    );
}


const Contenedor = styled(Container)`
    margin-top: 4%;
    
    
`

const FilaCursos = styled(Row)`
    max-width: 90%;
    
`

const CuerpoCursos = styled(Col)`
    box-shadow: 0px 0px 10px 0px rgba(157.5, 157.5, 157.5, 0.5);
    margin: auto !important ;
    margin-top: 70px !important;
    padding: 4% 3% 3% !important;
    padding-bottom: auto !important;

    @media screen and (max-width: 768px) {
        margin-left: 10% !important;
        margin-right: 100px !important;
        
    }

    
    
`











export default FormularioCurso;




